import Vue from "vue";
import App from "./App.vue";
import router from "./routes";
import store from "./store";
// import "./assets/style/./reset.css";
// import "./assets/style/global.css";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
Vue.use(Antd);
// Vue.prototype.$antdConfirm = Vue.prototype.$confirm;

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import VueParticles from "vue-particles"; //粒子特效
Vue.use(VueParticles);

import { VUE_PROTOTYPE_URL } from '@/config'
Vue.prototype.$urlbase = VUE_PROTOTYPE_URL;

// import * as filters from './filters' // 全局filter

// 加载过滤器
// Object.keys(filters).forEach(key => {
//     Vue.filter(key, filters[key])
// })
/* 全局指令:水波纹 */
import waves from "@/directive/waves/index.js";
Vue.directive("waves", waves);

// Vue.config.productionTip = false

// 检查是否从 HIS SSO 跳转到登录页，如果是则显示错误信息
function checkLoginError() {
  const error = new URLSearchParams(window.location.search).get('error')
  if (error) {
    // 在登录页面显示错误信息
    setTimeout(() => {
      Vue.prototype.$message.error('登录失败: ' + decodeURIComponent(error))
    }, 500)
  }
}

// 应用启动
new Vue({
  render: (h) => h(App),
  router,
  store,
  created() {
    // 检查登录错误信息
    checkLoginError()
  },
}).$mount("#app");
